import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import * as toastr from 'toastr'

import { RetornoGetVendedoresSemAgendamento, GetVendedoresSemAgendamentoParameters, ExportarVendedoresSemAgendamentoParameters } from '../../services/models';
import { UserTypes } from '@shared/enums';
import { User } from '@shared/models';
import { ConsultRequest } from '@shared/utils/consult-request';
import { FiltersOfConsult } from '@shared/utils/filters-of-consult';
import { RequestWithFetchStatus } from '@shared/utils/request-with-fetch-status';
import { Utilservice } from '@core/services/util.service';

import { VisitasService } from '../../services/visitas.service';

import { Filters } from './vendedores-sem-agendamento.component.models';

@Component({
  selector: 'app-vendedores-sem-agendamento',
  templateUrl: './vendedores-sem-agendamento.component.html',
  styleUrls: ['./vendedores-sem-agendamento.component.css']
})
export class VendedoresSemAgendamentoComponent implements OnInit {
  UserTypes = UserTypes;
  userLogado: User;

  filtersOfConsult = new FiltersOfConsult<Filters>({
    setor: null,
    dataInicial: moment().startOf('isoWeek').format('YYYY-MM-DD'),
    dataFinal: moment().endOf('isoWeek').format('YYYY-MM-DD'),
  });

  setoresRequest = new ConsultRequest<any[]>();
  constultaRequest = new ConsultRequest<RetornoGetVendedoresSemAgendamento[]>()
  exportRequest = new RequestWithFetchStatus<any>()

  week = {
    start: moment().startOf('isoWeek'),
    end: moment().endOf('isoWeek'),
    formatedStart: moment().startOf('isoWeek').format('DD/MM/YYYY'),
    formatedEnd: moment().endOf('isoWeek').format('DD/MM/YYYY')
  };

  constructor(
    private visitService: VisitasService,
  ) { }

  ngOnInit() {
    const user = localStorage.getItem("user_logado");
    this.userLogado = JSON.parse(user);

    this.getSetores()
  }

  changeWeek(direction: string): void {
    const currentWeek = this.week;

    const date = direction == 'back' ?
      moment(currentWeek.start).subtract(7, 'd') : moment(currentWeek.end).add(1, 'd');

    this.week = {
      start: moment(date.startOf('isoWeek')),
      end: moment(date.endOf('isoWeek')),
      formatedStart: date.startOf('isoWeek').format('DD/MM/YYYY'),
      formatedEnd: date.endOf('isoWeek').format('DD/MM/YYYY')
    }

    this.filtersOfConsult.filters.dataInicial = date.startOf('isoWeek').format('YYYY-MM-DD');
    this.filtersOfConsult.filters.dataFinal = date.endOf('isoWeek').format('YYYY-MM-DD');
  }

  onConsultar(){
    const params = this.getParams();

    if(!params) return;

    this.constultaRequest.get(
      this.visitService.getVendedoresSemAgendamento(params)
    )

  }

  resetFilters(){
    this.filtersOfConsult.resetAll()
  }

  handleExport(){
    const params = this.getParams();

    if(!params) return;

    this.exportarVendedoresSemAgendamento(params);
  }

  //metodos privados

  private getSetores(){
    if(this.userLogado.perfil == 2){
      const {idSetor, setor} = this.userLogado;
      const {filters} = this.filtersOfConsult

      filters.setor = {
        id: idSetor,
        codigo: setor,
      }
    }else{
      this.setoresRequest.get(
        this.visitService.getSetores()
      )
    }
  }

  private getParams(){
    const {setor, dataInicial, dataFinal} = this.filtersOfConsult.filters;

    if(!dataInicial || !dataFinal){
      toastr.error('Período Obrigatório')
      return null;
    }

    const params: GetVendedoresSemAgendamentoParameters = {
      dataInicial,
      dataFinal
    }

    if(setor) params.codigoRegional = setor.codigo;

   return params;
  }

  private exportarVendedoresSemAgendamento(params: ExportarVendedoresSemAgendamentoParameters){
    this.exportRequest.get(
      this.visitService.exportarVendedoresSemAgendamento(params)
    ).subscribe(
      response => {
        Utilservice.exportToFile(
          response.blob(),
          `exportacao-vendedores-sem-agendamento ${moment().format('DD/MM/YYYY HH:mm:ss')}.xls`
        )
      }
    )
  }

}
